//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import { computed, defineComponent } from "@vue/composition-api";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "EmailVerificationBanner",
  components: {
    FixedBanner
  },
  props: {
    positionFixed: {
      type: Boolean,
      default: false
    },
    sideRight: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      t
    } = useI18n();
    const {
      APPLICATION_IS_LOCKED
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.APPLICATION_IS_LOCKED]);
    const applicationIsLocked = computed(() => APPLICATION_IS_LOCKED.value);
    const bannerMessage = computed(() => t("application-standalone.pages.submit.applicationLockedMessage"));
    return {
      applicationIsLocked,
      bannerMessage
    };
  }
});